export const SET_LOADING = 'SET_LOADING';
export const SET_PROGRESS = 'SET_PROGRESS';